import logo from "../assets/BiorLabs-white.svg";
import { Link, useLocation } from "react-router-dom";
import responsive from "../assets/responsive.svg";
import ProductFlipToggle from "./Components/ProductFlipToggle";

export const Header = ({ onMenuOpen }) => {
  const location = useLocation();
  const isLanding = location.pathname === "/";

  return (
    <header
      className="fixed z-[100] w-full"
      style={{
        paddingTop: "var(--safe-area-top)",
        background: "rgba(21, 14, 83, 0.65)",
        backdropFilter: "blur(28px) saturate(180%)",
        WebkitBackdropFilter: "blur(28px) saturate(180%)",
        borderBottom: "1px solid rgba(255,255,255,0.06)",
      }}
    >
      <div className="relative flex h-[3.4rem] w-full items-center justify-between px-6 sm:px-10 lg:px-16">

        {/* Logo */}
        <Link
          to="/"
          aria-label="Go to homepage"
          data-testid="header-logo"
          className="flex-shrink-0 opacity-90 transition-opacity hover:opacity-100"
        >
          <img
            src={logo}
            alt="BiorLabs"
            className="h-[1rem] sm:h-[1.25rem] w-auto"
          />
        </Link>

        {/* Mobile inline flip toggle — between logo and hamburger on landing */}
        {isLanding ? (
          <div className="md:hidden">
            <ProductFlipToggle />
          </div>
        ) : null}

        {/* Centered product flip toggle — only visible on landing (desktop) */}
        {isLanding ? (
          <div className="header-product-flip-wrap hidden md:block">
            <ProductFlipToggle />
          </div>
        ) : null}

        {/* Desktop: nav links + CTA */}
        <div className="hidden sm:flex items-center gap-1">

          <nav
            className="flex items-center gap-0.5 p-1 rounded-2xl"
            style={{
              background: "rgba(14, 13, 41, 0.5)",
              border: "1px solid rgba(255,255,255,0.06)",
            }}
          >
            <Link to="/cards" data-testid="nav-cards" className="header-nav-pill font-dm">
              Cards
            </Link>
            <Link to="/faq" data-testid="nav-faq" className="header-nav-pill font-dm">
              FAQ
            </Link>
            <Link to="/tos" data-testid="nav-tos" className="header-nav-pill font-dm">
              Terms
            </Link>
          </nav>

        </div>

        {/* Mobile: hamburger */}
        <button
          type="button"
          aria-label="Open menu"
          data-testid="mobile-menu-btn"
          className="sm:hidden block"
          onClick={onMenuOpen}
        >
          <img
            src={responsive}
            alt=""
            aria-hidden="true"
            className="brightness-0 invert w-5 h-5"
          />
        </button>

      </div>
    </header>
  );
};
